// extracted by mini-css-extract-plugin
export default {"Currency":"Currency_Currency__2gC9M"};